import { API } from 'aws-amplify';

// @ts-ignore
export const create = (one) => API.put('ihrespezialistenBackend', '/press', { body: one });

// @ts-ignore
export const read = () => API.get('ihrespezialistenBackend', '/press', {});

// @ts-ignore
export const readOne = (id) => API.get('ihrespezialistenBackend', `/press/${id}`, {});

// @ts-ignore
export const update = (one) => API.post('ihrespezialistenBackend', `/press/${one.id}`, { body: one });

// @ts-ignore
export const remove = (id) => API.del('ihrespezialistenBackend', `/press/${id}`, {});
